import styled, { createGlobalStyle } from 'styled-components';
import { media } from 'styled-bootstrap-grid';

const BAR_HEIGHT = 76;

export const OptionsButtonWrapper = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 10px 20px 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  z-index: 2;
  box-shadow: 0px -3px 9px #0000000d;

  ${media.lg`
    display: none;
  `}
`;

export const PriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: ${({ theme }) => theme.spaces.space2};
`;

export const GlobalStyle = createGlobalStyle`
  body {
    padding-bottom: ${`${BAR_HEIGHT}px`};
  }

  ${media.lg`
    body {
      padding-bottom: initial;
    }
  `}
`;
